import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as StyledHomeAndCompaniesTable from './homeAndCompaniesTable.styles';

interface Props {
	data: any;
}

const HomeAndCompaniesTable: FC<Props> = ({ data }) => {
	const { t } = useTranslation('generalPostInfo');
	if (!data) return null;
	return (
		<StyledHomeAndCompaniesTable.Wrapper>
			<table>
				<thead>
					<tr>
						<th>{t('homes-and-companies.postcode')}</th>
						<th>{t('homes-and-companies.place')}</th>
						<th>{t('homes-and-companies.homes')}</th>
						<th>{t('homes-and-companies.companies')}</th>
						<th>{t('homes-and-companies.homes-and-companies')}</th>
					</tr>
				</thead>
				<tbody>
					{data.map(region => {
						return region.postcodesList.map(postcode => (
							<tr key={postcode.postcode}>
								<td>{postcode.postcode}</td>
								<td>{postcode.place}</td>
								<td>{postcode.totalHomes}</td>
								<td>{postcode.totalCompanies}</td>
								<td>{postcode.totalHomesAndCompanies}</td>
							</tr>
						));
					})}
				</tbody>
			</table>
		</StyledHomeAndCompaniesTable.Wrapper>
	);
};

export default HomeAndCompaniesTable;
